import { squareConfig as sq } from '../const/Square';
import { getDynamicEnviroment } from '../yoello-lib/modules/utils/enviromentSetup';

export const useSquareAuth = () => {
    let env = getDynamicEnviroment();
    let squareUrl = `https://${sq.domains[env]}.com${sq.cookieUrls[env]}/oauth2/authorize?client_id=${sq.clientIDs[env]}&scope=${sq.scopes[env].join("+")}&session=${sq.sessions[env]}`;
    return { squareUrl }
}

export const useSquareOrders = (id: string) => {
    let env = getDynamicEnviroment();
    let squareUrl = `https://${sq.domains[env]}.com/dashboard/orders/overview/${id}`;
    return { squareUrl }
}